export default __webpack_public_path__ + "static/media/fi.f972d4ad.svg";